import { Injectable } from '@angular/core';
import { BalanceSheetExportQuery, BalanceSheetExportQueryHandlerBase } from '@skylab-shared/business';

import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(BalanceSheetExportQuery)
@Wrapper(BalanceSheetExportQueryHandlerBase)
export class BalanceSheetExportQueryHandler {
    public constructor(
        http: Http
    ) { }
}
